import BaseLogo from './BaseLogo'

export default BaseLogo
